module.exports = __webpack_public_path__ + "green-checkmark.png";